module.exports = __webpack_public_path__ + "static/media/nac.3aa97227.svg";